import React from 'react';

/**
 * FeatureGrid — Clean feature cards with monochrome icons.
 */
const FEATURES = [
    {
        icon: '⚡',
        title: '60-Second Rounds',
        description: 'Every minute is a new market. Pick Up or Down, lock in, settle in 60 seconds.',
    },
    {
        icon: '◉',
        title: 'Live Charts',
        description: 'Real-time candlestick charts powered by Coinbase and Birdeye data feeds.',
    },
    {
        icon: '⬡',
        title: 'Fair Odds',
        description: 'Parimutuel pools — no house trading against you. Winners split the losers\' pot.',
    },
    {
        icon: '◈',
        title: 'Fully Transparent',
        description: 'Every bet, pool, and settlement is visible. Odds update in real time.',
    },
];

const FeatureGrid = () => (
    <section className="relative z-10 max-w-5xl mx-auto px-6 py-24">
        <div className="text-center mb-16">
            <p className="text-[10px] uppercase tracking-[0.4em] text-slate-600 font-semibold mb-4">
                How it works
            </p>
            <h2 className="text-2xl md:text-3xl font-black tracking-[-0.02em] text-white">
                Built for speed
            </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {FEATURES.map(({ icon, title, description }, i) => (
                <div
                    key={title}
                    className={`glass-card rounded-xl p-6 animate-in animate-in-d${i + 1} group`}
                >
                    <div className="feature-icon mb-5">
                        {icon}
                    </div>
                    <h3 className="text-[11px] font-black uppercase tracking-[0.15em] text-white mb-2.5">
                        {title}
                    </h3>
                    <p className="text-[11px] text-slate-600 leading-[1.7] font-light">
                        {description}
                    </p>
                </div>
            ))}
        </div>
    </section>
);

export default FeatureGrid;
